module.exports = __webpack_public_path__ + "static/media/invoices.b0540d21.svg";